import { h, render } from 'vue'
import BuffStrip from '@/components/buffs/BuffStrip.vue'
import { buffCompositionLayout } from './layout'
import { defaultBuffPreferences, enabledBuffCount } from './types'
import { getBuffOverlay, reorderBuffOverlay } from './overlay-source'
import { buffPresentationKey } from '@/ui/widget-presentation'
import { performanceDiagnostics } from '@/services/performance-diagnostics'
export function createBuffComposition(document: Document, getSnapshot = getBuffOverlay) {
  const shell = document.createElement('div'), stats = document.createElement('div')
  const core = document.createElement('div')
  core.className = 'buff-exp-core'; stats.append(core)
  shell.className = 'buff-composition'; stats.className = 'buff-stat-slot'
  shell.append(stats); document.body.append(shell)
  Object.assign(shell.style, { display: 'grid', gridTemplateColumns: 'minmax(0,1fr)', gridTemplateRows: 'minmax(0,1fr)' })
  shell.dataset.tier = 'full'
  let key = '', resizeKey = '', railKey = '', railHost: HTMLElement | null = null
  const clearRail = () => { if (railHost) render(null, railHost); railHost = null; railKey = '' }
  return { stats, theme(skin: string, background: string) {
    if (skin.startsWith('stream-')) shell.dataset.streamSkin = skin
    else delete shell.dataset.streamSkin
    if (shell.style.getPropertyValue('--buff-widget-bg') !== background) shell.style.setProperty('--buff-widget-bg', background)
  }, updateStats(value: string, label: string) {
    const text = `${label} · ${value}`
    if (core.textContent !== text) core.textContent = text
  }, invalidateLayout() { key = '' }, update(stream = Boolean(shell.dataset.streamSkin), snapshot = getSnapshot()): boolean {
    const count = enabledBuffCount(snapshot)
    const next = JSON.stringify([count, snapshot?.items.length ?? 0, stream, snapshot?.layout])
    const changed = next !== key
    if (changed) {
      const started = performance.now()
      try {
        const layout = buffCompositionLayout(shell.clientWidth || document.defaultView?.innerWidth || 360, shell.clientHeight || document.defaultView?.innerHeight || 280, snapshot?.items.length ?? 0, snapshot?.layout ?? defaultBuffPreferences().layout, count)
        shell.dataset.hasBuffs = String(layout.buffs)
        const targetKey = stream || !layout.buffs ? '' : `buffs:${count}`
        const win = document.defaultView
        if (targetKey && targetKey !== resizeKey && win && !win.frameElement) {
          resizeKey = targetKey
          try { win.resizeBy(0, layout.requiredHeight) } catch { /* Browser restrictions keep the current window. */ }
        } else resizeKey = targetKey
        key = next
      } finally { performanceDiagnostics.measure('widget-composition', performance.now() - started) }
    }
    const anchor = stream ? null : stats.querySelector<HTMLElement>('[data-buff-anchor]')
    if (!anchor || !snapshot || !count) clearRail()
    else {
      const nextRailKey = buffPresentationKey(snapshot)
      if (anchor !== railHost || nextRailKey !== railKey) {
        if (anchor !== railHost) clearRail()
        anchor.hidden = false
        render(h(BuffStrip, { snapshot, compact: true, iconSize: 36, reorder: reorderBuffOverlay }), anchor)
        railHost = anchor; railKey = nextRailKey
      }
    }
    if (anchor && !count) anchor.hidden = true
    return changed
  }, dispose() { clearRail(); shell.remove() } }
}
